// frontend/src/shared/components/NavIcon.tsx
import React from 'react';
import { Box } from '@mui/material';

interface NavIconProps {
  src: string;
  size?: number;
  alt?: string;
  sx?: object;
}

const NavIcon: React.FC<NavIconProps> = ({ src, size = 24, alt = '', sx = {} }) => (
  <Box
    component="img"
    src={src}
    alt={alt}
    aria-hidden={!alt}
    sx={{
      width: size,
      height: size,
      objectFit: 'contain',
      display: 'block',
      flexShrink: 0,
      ...sx,
    }}
  />
);

export default NavIcon;
